// extracted by mini-css-extract-plugin
module.exports = {"content":"Caption_content__Zyvam","root___dark":"Caption_root___dark__u3r9g","root___light":"Caption_root___light__MqOwI"};